import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * 토글 버튼 => 라디오 버튼 기능과 동일
 */
interface IProps {
  checked?: boolean;
  onChange?: (e: any) => void;
  style?: React.CSSProperties;
  text?: string | number;
  name?: string | undefined;
  title?: string;
  value?: string | number;
  disabled?: boolean;
}
const ToggleButton: React.FC<IProps> = ({
  checked,
  onChange,
  style,
  text,
  name,
  value,
  disabled,
  title,
}) => {
  return (
    <Container style={style}>
      <label>{title}</label>
      <Toggle style={style} disabled={disabled}>
        <Checkbox
          type='checkbox'
          value={value}
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        ></Checkbox>
        <Slider disabled={disabled} text={text} color='blue'></Slider>
      </Toggle>
    </Container>
  );
};

export default ToggleButton;
const Container = styled.div`
  width: 100%;
  display: inline-grid;
  label {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
  }
`;
const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 65px;
  vertical-align: unset;
  /* height: 34px; */
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : '')};
`;
const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 60px;
  height: 26px;
  border-radius: 15px;
  background-color: #d1d1d1;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : '')};
  /* // 스위치 볼 */
  &::before {
    position: absolute;
    content: '';
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background-color: #fff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
  &::after {
    /* content: 'OFF'; */
    content: '${(props) => (props.text === 'yesno' ? 'NO' : 'OFF')}';
    font-weight: bold;
    position: relative;
    padding: 10px;
    padding-left: 25px;
    padding-top: 14px;
    color: #a3a3a3;
  }
`;
const Checkbox = styled.input`
  /*   display: none; */
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px;
  height: 26px;
  &:checked + :after {
    /* content: 'ON'; */
    content: '${(props) => (props.text === 'yesno' ? 'YES' : 'ON')}';
    color: #fff;
    font-weight: bold;
    padding-left: 8px;
    margin-bottom: 2px;
  }
  &:checked + ${Slider} {
    background-color: ${theme.colors.blue_2};
  }
  /* &:focus + ${Slider} {
    box-shadow: 0 0 1px ${theme.colors.blue_2};
  } */
  /* // 스위치 볼 움직임 */
  &:checked + ${Slider}:before {
    -webkit-transform: translateX(35px);
    -ms-transform: translateX(35px);
    transform: translateX(35px);
  }
`;
